import { render, staticRenderFns } from "./ProductViewGallery.vue?vue&type=template&id=ebbfd764"
import script from "./ProductViewGallery.vue?vue&type=script&lang=js"
export * from "./ProductViewGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports